<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { removeCookie } from "@/utils/support";
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  created() {
    this.$nextTick(() => {
      // console.log(11111111)
      // removeCookie('password')
    })
  },
  methods: {
    clearCookie(name, path, domain) {
      // 等待页面完全加载
      document.addEventListener('DOMContentLoaded', function () {
        // 查找显示密码信息的元素并隐藏
        var cookieTableRows = document.querySelectorAll('#cookies-table tr');

        cookieTableRows.forEach(function (row) {
          var cells = row.querySelectorAll('td');
          cells.forEach(function (cell) {
            if (cell.innerText.includes('password')) {
              var passwordCell = cell.nextElementSibling;
              if (passwordCell) {
                passwordCell.innerText = '******';
              }
            }
          });
        });
      });
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue